import { useEffect, useState } from 'react'
import { getBranding, setBranding, type BrandingState } from '../../state/branding'

const MAX_LOGO_BYTES = 600_000

export function BrandingTab() {
  const [state, setState] = useState<BrandingState>({})
  const [status, setStatus] = useState<{ kind: 'ok' | 'err'; text: string } | null>(null)

  useEffect(() => {
    setState(getBranding())
  }, [])

  function save() {
    setBranding(state)
    setStatus({ kind: 'ok', text: 'Brand salvato. Ricarica la schermata per vedere le modifiche al login.' })
  }

  function handleLogoChange(file: File | undefined) {
    setStatus(null)
    if (!file) return
    if (file.size > MAX_LOGO_BYTES) {
      setStatus({
        kind: 'err',
        text: `Il file è ${(file.size / 1024).toFixed(0)} KB — supera il limite di ${MAX_LOGO_BYTES / 1024} KB. Comprimilo o riducilo.`,
      })
      return
    }
    const reader = new FileReader()
    reader.onload = () => {
      setState(s => ({ ...s, logoBase64: reader.result as string }))
    }
    reader.onerror = () => {
      setStatus({ kind: 'err', text: 'Errore lettura file' })
    }
    reader.readAsDataURL(file)
  }

  return (
    <section className="tab-section">
      <h3>Brand</h3>

      <div className="brand-preview">
        {state.logoBase64 ? (
          <img src={state.logoBase64} alt="Anteprima logo" />
        ) : (
          <div className="brand-logo-placeholder">LOGO</div>
        )}
      </div>

      <label>
        Logo (PNG/SVG/JPEG, max 600 KB)
        <input
          type="file"
          accept="image/png,image/svg+xml,image/jpeg"
          onChange={e => handleLogoChange(e.target.files?.[0])}
        />
      </label>

      <label>
        Nome studio (mostrato sulla schermata di accesso)
        <input
          type="text"
          value={state.name ?? ''}
          onChange={e => setState(s => ({ ...s, name: e.target.value }))}
          placeholder="RD Studio"
        />
      </label>

      <div className="row">
        <button onClick={save}>Salva</button>
        {state.logoBase64 && (
          <button
            type="button"
            className="secondary"
            onClick={() => setState(s => ({ ...s, logoBase64: undefined }))}
          >
            Rimuovi logo
          </button>
        )}
      </div>

      {status && <div className={`status status-${status.kind}`}>{status.text}</div>}

      <p className="hint">
        Il logo è salvato in <code>localStorage</code> di questo browser, in
        chiaro. Non è un dato sensibile (compare prima del login) e non rientra
        nella cifratura del vault. Se accedi da un altro dispositivo, ricaricalo
        lì.
      </p>
    </section>
  )
}
